import * as petChatbotRuleset from './petChatbot.ruleset';
import { petChatbotScheduledActions } from './petChatbot.scheduledActions';
import { Pet } from '../pet';
import { Profile } from '../../profile';
import { petChatbotActions } from './petChatbot.actions';
import { VisitRecord } from '../../visit/record';
import { Inventory } from '../inventory';
import { Level } from '../level';
import { History } from '../history';

export type {
  PetChatTime,
  PetMessage,
  PetStatusNotification,
} from './petChatbot.ruleset';

export type PetChatbot = typeof PetChatbot;
// eslint-disable-next-line no-redeclare
export namespace PetChatbot {
  export const ruleset = petChatbotRuleset;
  export const scheduledActions = petChatbotScheduledActions(
    PetChatbot,
    Pet,
    Profile,
    VisitRecord,
    Inventory,
    Level,
    History,
  );
  export const actions = petChatbotActions(PetChatbot);
}
